import Vue from 'vue';


export default {
  state: {},
  actions: {
    // 建议反馈
    feedbackAdd(ctx, params){
      return Vue.http.post('/client/userFeedback/feedback-add', params)
    }
  },
  mutations: {},
  getters: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/userFeedback.js